import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'shared/api'
import { IS_TMS_DELIVERY } from 'shared/config'
import { isClient } from 'shared/utils/common'

import { getDeliverySlotsByDeliveryMethodIdService } from '../api'

const CACHE_TIME_MS = 1000 * 60 * 60 * 2

export default function useQueryDeliverySlots(
  deliveryMethodId: string | null,
  token?: string
) {
  return useQuery({
    queryKey: [QueryKey.deliverySlots, deliveryMethodId],
    queryFn: () =>
      getDeliverySlotsByDeliveryMethodIdService({
        deliveryMethodId: deliveryMethodId as string,
        token
      }),
    refetchOnWindowFocus: true,
    staleTime: CACHE_TIME_MS,
    gcTime: isClient() ? CACHE_TIME_MS : Infinity,
    enabled: !IS_TMS_DELIVERY && !!deliveryMethodId
  })
}
